export const exportToPDF = (htmlContent: string, filename: string) => {
  // Create a new window/tab
  const printWindow = window.open('', '_blank');
  
  if (!printWindow) {
    return false;
  }

  // Write HTML content to new window
  printWindow.document.write(htmlContent);
  printWindow.document.close();

  // Wait for content to load, then trigger print
  printWindow.onload = () => {
    // Small delay to ensure styles are applied
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 250);
  };

  return true;
};

// Alternative: Download as HTML file
export const downloadAsHTML = (htmlContent: string, filename: string) => {
  const blob = new Blob([htmlContent], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.html`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
